interface PaginateProps<T> {
	items: T[];
	pageIndex: number;
	pageSize: number;
}

function paginate<T>({ items, pageIndex, pageSize }: PaginateProps<T>) {
	if (pageIndex === 0) {
		throw new Error("PageIndex cannot be 0");
	}

	const start = (pageIndex - 1) * pageSize;
	const end = start + pageSize;
	return items.slice(start, end);
}

export default paginate;
